import { Box, Stack, Typography } from "@mui/material";
import { ArrowLeft } from "lucide-react";
import { COLORS } from "../../Styles/Colors";
import { BackButton } from "../../Styles/AppStyles";

interface HeaderProps {
    title?: string;
    subtitle?: string;
    onExport?: () => void;
    data?: any[];
    children?: React.ReactNode;
    count?: number;
    hideCount?: boolean;
    onBack?: () => void;

}



function resolveRecordCount(data: HeaderProps['data'], count?: number): number {
  if (count != null) return count;
  if (Array.isArray(data)) return data.length;
  if (data && typeof data === 'object' && 'totalCount' in data) {
    return Number((data as { totalCount?: number }).totalCount) || 0;
  }
  return 0;
}

export const Header = ({title, subtitle, data = [], children, count, hideCount = false, onBack} : HeaderProps) => {
    return (
        <Box sx={{ p: { xs: 1.25, md: 3 }, backgroundColor: '#f8f9fa', flexShrink: 0 }}>
         {onBack && (
                <Box sx={{ mb: 2 }}>
                  <BackButton onClick={onBack}>
                    <ArrowLeft size={16} />
                    Back
                  </BackButton>
                </Box>
              )}
         {(title || subtitle) && (
                <Box sx={{ mb: { xs: 0.75, md: 3 } }}>
                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent="space-between"
                    alignItems={{ xs: 'stretch', sm: 'flex-start' }}
                    spacing={{ xs: 0.75, sm: 2 }}
                    sx={{ mb: { xs: 0, sm: 2 } }}
                  >
                    <Box sx={{ minWidth: 0 }}>
                      {title && (
                        <Typography
                          variant="h4"
                          component="h1"
                          fontWeight="bold"
                          sx={{ mb: { xs: 0, md: 1 }, fontSize: { xs: '1.25rem', md: '2.125rem' } }}
                        >
                          {title}
                        </Typography>
                      )}
              
                    
                        {subtitle && (
                          <Typography variant="body1" color={COLORS.teal}>
                            {subtitle}
                          </Typography>
                        )}
                        
                        {hideCount && ( <Box sx={{ 
                          px: 2, 
                          py: 0.5, 
                          borderRadius: 1,
                          display: 'inline-block',
                          fontSize: '0.875rem',
                          fontWeight: 500,
                          color: COLORS.teal,
                          mt: 1
                        }}>



                          {resolveRecordCount(data, count)} Records (Total)
                        </Box>)}
                    

                     
                    </Box>

                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        gap: 1,
                        minWidth: 0,
                        '& > *': { maxWidth: '100%' },
                      }}
                    >
                       {children}
                    </Box>
                    
                   
                  </Stack>
                </Box>
              )}

        </Box>
        
    )
}